// src/components/Pricing.js
import React from 'react';

const Pricing = () => {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-4xl text-white font-extrabold mb-8 text-center">Pricing Plans</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Basic Plan */}
        <div className="border border-gray-700 rounded-lg shadow-lg p-6 bg-gray-800 text-white">
          <h2 className="text-2xl font-bold mb-4">Basic</h2>
          <p className="text-lg mb-6">$19/month</p>
          <ul className="mb-6 space-y-2">
            <li>✔️ Access to 10 modules</li>
            <li>✔️ Basic analytics</li>
            <li>✔️ Email support</li>
          </ul>
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-semibold transition duration-300">
            Choose Basic
          </button>
        </div>
        {/* Pro Plan */}
        <div className="border border-gray-700 rounded-lg shadow-lg p-6 bg-gray-800 text-white">
          <h2 className="text-2xl font-bold mb-4">Pro</h2>
          <p className="text-lg mb-6">$49/month</p>
          <ul className="mb-6 space-y-2">
            <li>✔️ Access to 50 modules</li>
            <li>✔️ Advanced analytics</li>
            <li>✔️ Priority email support</li>
            <li>✔️ Custom integrations</li>
          </ul>
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-semibold transition duration-300">
            Choose Pro
          </button>
        </div>
        {/* Enterprise Plan */}
        <div className="border border-gray-700 rounded-lg shadow-lg p-6 bg-gray-800 text-white">
          <h2 className="text-2xl font-bold mb-4">Enterprise</h2>
          <p className="text-lg mb-6">Contact us for pricing</p>
          <ul className="mb-6 space-y-2">
            <li>✔️ Unlimited module access</li>
            <li>✔️ Full analytics suite</li>
            <li>✔️ Dedicated account manager</li>
            <li>✔️ Custom solutions</li>
          </ul>
          <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-full font-semibold transition duration-300">
            Contact Sales
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
